import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRef } from 'react';
import agentPageStore from '../store';
import BlockList from './block-list';
import { useEffect } from 'react';
import TopTab from './top-tab';

const ListItem = observer(({ item, scroll, index, className = '' }) => {
  const isExample = item.category == 'example';
  const isRecommend = item.category == 'recommend';
  const disTop = isRecommend ? 60 : -31;
  const magicRef = useRef(null);
  const topTabRef = useRef(null);
  //滚动时切换tab
  console.log('scroll is', scroll)
  useEffect(() => {
    if (scroll - magicRef?.current?.offsetTop >= (isRecommend ? -50 : -104)) {
      agentPageStore.switchTab(index);
    }
    if (topTabRef.current) {
      agentPageStore.toggleTopTab(
        scroll > topTabRef.current.parentNode.offsetTop
      );
    }
  }, [scroll]);

  return (
    <div
      ref={magicRef}
      className={[
        'relative',
        'last:min-h-[calc(100vh-20px)]',
        isExample ? '' : 'py-16px',
        className,
      ]}
    >
      <div
        style={{ top: disTop }}
        className="list-item-magic absolute size-0"
      ></div>

      {isExample ? (
        null
      ) : (
        <>
          <div
            className={[
              'mb-4px text-black font-bold',
              isRecommend ? 'text-20px leading-28px' : 'text-16px leading-22px',
            ]}
          >
            {isRecommend ? '' : item.title}
          </div>
          {isRecommend ? (
            <TopTab
              ref={topTabRef}
              className="mb-23px mt-12px"
            />
          ) : (
            <div className="text-14px leading-20px mb-16px text-black text-opacity-50">
              {item.intro}
            </div>
          )}
          <BlockList list={item.list || []} isRecommend={isRecommend} />
        </>
      )}
    </div>
  );
});
export default ListItem;
